module.exports = __webpack_public_path__ + "static/img/投诉建议图标.cb730fa.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/投诉建议图标.png
// module id = Dzoz
// module chunks = 30